import useUserSearch, { FieldType, Payload } from './useUserSearch';
import { useMeetings } from '../MeetingsTool/MeetingsToolContext';
interface useUsersMeetingsProps {
    usersProfileIds: number[];
    isFetchingMeetings: boolean;
}

const useUsersMeetings = ({ usersProfileIds, isFetchingMeetings }: useUsersMeetingsProps) => {
    const { eventId } = useMeetings();

    const payload: Payload = {
        page: 0,
        size: usersProfileIds?.length,
        orders: {
            FIRST_NAME: 'ASC',
            LAST_NAME: 'ASC',
        },
        criteria: [
            {
                field: FieldType.USER_PROFILE_ID,
                value: usersProfileIds,
                action: 'IN',
            },
        ],
    };

    return useUserSearch({
        eventId,
        payload,
        options: {
            enabled: !!payload.size && !isFetchingMeetings,
        },
    });
};

export default useUsersMeetings;
